export const getReviewsForMemberQuery = `
    query GetReviewsForMember($id: ID!, $page: Int, $size: Int, 
       $sortType: ReviewsOrderByType!, $sort: Sort!) {
      reviews(
        input: {
        pagination: {page: $page, size: $size}, 
        filters: {
          memberId: $id
        }, 
        orderBy: {type: $sortType, sort: $sort}}
      ) {
        nodes {
          id
          userVerified
          highlighted
          content
          overallRating
          attributes {
            weddingDate
            budgetCost
            budgetGuestCount
          }
          comment {
            id
            commenterId
            createdAt
            updatedAt
          }
          photos {
            id
            name
            active
            createdAt
            updatedAt
            width
            height
            sortOrder
            sourceId
          }
          reviewer {
            id
            firstName
            lastName
            role
          }
          reviewees {
            storefrontId
          }
          disputed
          dispute {
            status
          }
        }
      }
    }
`;

export interface MemberReviewComment {
	id: string;
	commenterId: string;
	content: string;
	active: boolean;
	createdAt: string;
	updatedAt: string;
}

export interface MemberReviewPhoto {
	id: string;
	name?: string | null;
	active: boolean;
	width?: number | null;
	height?: number | null;
	sortOrder?: number | null;
	sourceId?: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface MemberReviewReviewee {
	storefrontId?: string | null;
}

export interface MemberReviewReviewer {
	id: string;
	memberId?: string | null;
	firstName?: string | null;
	lastName?: string | null;
	role?: string | null;
}

interface Dispute {
	status: string | null;
}

export interface MemberReview {
	id: string;
	content: string;
	userVerified: boolean;
	overallRating?: number | null;
	createdAt: string;
	updatedAt: string;
	reviewer: MemberReviewReviewer;
	reviewees: MemberReviewReviewee[];
	photos: MemberReviewPhoto[];
	comment?: MemberReviewComment | null;
	attributes?: MemberReviewAttribute | null;
	highlighted: boolean;
	disputed?: boolean | null;
	dispute?: Dispute | null;
}

export interface MemberReviewAttribute {
	weddingDate?: string | null;
	budgetCost?: number | null;
	budgetGuestCount?: number | null;
}
